(function () {
  "use strict";

  document.documentElement.classList.remove("no-js");
  document.documentElement.classList.add("js");

  var config = window.GORSELI_THEME || { routes: {} };
  var routes = config.routes || {};
  var dialogOpeners = new WeakMap();
  var headerResizeObserver;

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  function announce(message) {
    var region = document.querySelector("[data-live-region]");
    if (region) region.textContent = message;
  }

  function updateStickyHeaderOffsets() {
    var announcement = document.querySelector(".g-announcement");
    var header = document.querySelector("[data-site-header]");
    var announcementHeight = announcement ? Math.ceil(announcement.getBoundingClientRect().height) : 0;
    var headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;

    document.documentElement.style.setProperty("--g-announcement-height", announcementHeight + "px");
    document.documentElement.style.setProperty("--g-header-height", headerHeight + "px");
  }

  function initStickyHeader() {
    var announcement = document.querySelector(".g-announcement");
    var header = document.querySelector("[data-site-header]");

    updateStickyHeaderOffsets();
    if (headerResizeObserver) headerResizeObserver.disconnect();

    if (typeof window.ResizeObserver === "function") {
      headerResizeObserver = new ResizeObserver(updateStickyHeaderOffsets);
      if (announcement) headerResizeObserver.observe(announcement);
      if (header) headerResizeObserver.observe(header);
    }
  }

  function openDialog(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== "function") return;
    if (dialog.open) return;
    dialogOpeners.set(dialog, trigger || document.activeElement);
    dialog.showModal();
    document.body.classList.add("g-dialog-open");
  }

  function closeDialog(dialog) {
    if (!dialog || !dialog.open) return;
    dialog.close();
  }

  function initializeDialogs() {
    document.querySelectorAll("dialog[data-gorseli-search-dialog], dialog[data-gorseli-cart-dialog], dialog[data-gorseli-notify-dialog]").forEach(function (dialog) {
      if (dialog.dataset.initialized === "true") return;
      dialog.dataset.initialized = "true";
      dialog.addEventListener("close", function () {
        if (!document.querySelector("dialog[open]")) {
          document.body.classList.remove("g-dialog-open");
        }
        var opener = dialogOpeners.get(dialog);
        dialogOpeners.delete(dialog);
        if (opener && opener.isConnected && typeof opener.focus === "function") {
          opener.focus();
        }
      });
    });
  }

  function focusWaitlist(event) {
    var section = document.getElementById("waitlist");
    if (!section) {
      var notify = document.querySelector("[data-gorseli-notify-dialog]");
      if (notify) {
        if (event) event.preventDefault();
        openDialog(notify, event && event.currentTarget);
      }
      return;
    }
    if (event) event.preventDefault();
    section.scrollIntoView({ behavior: "smooth", block: "start" });
    window.setTimeout(function () {
      var input = section.querySelector('input[type="email"]');
      if (input) input.focus();
    }, 350);
  }

  function handleAction(event) {
    var target = event.target.closest("[data-gorseli-action]");
    if (!target) return;
    var action = target.dataset.gorseliAction;

    if (action === "open-search") {
      event.preventDefault();
      openDialog(document.querySelector("[data-gorseli-search-dialog]"), target);
    } else if (action === "close-search") {
      event.preventDefault();
      closeDialog(document.querySelector("[data-gorseli-search-dialog]"));
    } else if (action === "open-cart") {
      event.preventDefault();
      openDialog(document.querySelector("[data-gorseli-cart-dialog]"), target);
    } else if (action === "close-cart") {
      event.preventDefault();
      closeDialog(document.querySelector("[data-gorseli-cart-dialog]"));
    } else if (action === "open-notify") {
      event.preventDefault();
      openDialog(document.querySelector("[data-gorseli-notify-dialog]"), target);
    } else if (action === "close-notify") {
      event.preventDefault();
      closeDialog(document.querySelector("[data-gorseli-notify-dialog]"));
    }
  }

  function initWaitlist() {
    document.querySelectorAll("[data-focus-waitlist]").forEach(function (link) {
      if (link.dataset.waitlistInitialized === "true") return;
      link.dataset.waitlistInitialized = "true";
      link.addEventListener("click", focusWaitlist);
    });

    document.querySelectorAll(".g-waitlist-form, .g-notify-panel form").forEach(function (form) {
      var formSuccess = form.querySelector("[data-waitlist-success]");
      if (!formSuccess) return;

      var eventKey = "gorseli_waitlist_success:" + (form.id || "gorseli_waitlist") + ":" + window.location.pathname;
      var alreadyRecorded = false;
      try {
        alreadyRecorded = window.sessionStorage.getItem(eventKey) === "1";
      } catch (error) {
        alreadyRecorded = false;
      }

      if (!alreadyRecorded) {
        var eventData = {
          method: "email",
          form_id: form.id || "gorseli_waitlist",
          form_source: form.closest("#waitlist") ? "early_access_home" : "back_in_stock",
          consent_type: "email_marketing",
          subscription_status: "pending_or_subscribed"
        };

        document.dispatchEvent(new CustomEvent("gorseli:waitlist-signup", { detail: eventData }));
        if (
          window.Shopify &&
          Shopify.analytics &&
          typeof Shopify.analytics.publish === "function"
        ) {
          Shopify.analytics.publish("gorseli:waitlist_signup", eventData);
        }

        try {
          window.sessionStorage.setItem(eventKey, "1");
        } catch (error) {
          // Analytics must never interrupt the customer form experience.
        }
      }

      var successDialog = formSuccess.closest("[data-gorseli-notify-dialog]");
      if (successDialog) openDialog(successDialog);
      formSuccess.focus();
      formSuccess.scrollIntoView({ block: "center" });
    });
  }

  function initMobileMenu() {
    var button = document.querySelector("[data-menu-button]");
    var menu = document.querySelector("[data-mobile-menu]");
    if (!button || !menu || button.dataset.initialized === "true") return;
    button.dataset.initialized = "true";

    function setOpen(open) {
      button.setAttribute("aria-expanded", String(open));
      menu.hidden = !open;
      document.body.classList.toggle("menu-open", open);
      if (open) {
        var first = menu.querySelector("a");
        if (first) first.focus();
      }
    }

    button.addEventListener("click", function () {
      setOpen(button.getAttribute("aria-expanded") !== "true");
    });
    menu.addEventListener("click", function (event) {
      if (event.target.closest("a")) setOpen(false);
    });
  }

  async function changeCart(line, quantity, button) {
    if (!routes.cartChange) return;
    button.disabled = true;
    try {
      var response = await fetch(routes.cartChange, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      if (!response.ok) throw new Error("Unable to update the bag.");
      window.location.reload();
    } catch (error) {
      announce(error.message || "Unable to update the bag.");
      button.disabled = false;
    }
  }

  function initCartChanges() {
    document.querySelectorAll("[data-gorseli-cart-change]").forEach(function (button) {
      if (button.dataset.initialized === "true") return;
      button.dataset.initialized = "true";
      button.addEventListener("click", function () {
        changeCart(button.dataset.gorseliCartChange, button.dataset.gorseliCartQuantity, button);
      });
    });
  }

  ready(function () {
    initializeDialogs();
    document.addEventListener("click", handleAction);
    initWaitlist();
    initMobileMenu();
    initCartChanges();
    initStickyHeader();
    window.addEventListener("resize", updateStickyHeaderOffsets, { passive: true });
  });

  document.addEventListener("shopify:section:load", function () {
    initializeDialogs();
    initWaitlist();
    initMobileMenu();
    initCartChanges();
    initStickyHeader();
  });
})();
